import { useCallback, useEffect } from 'react';

export const useOutsideClickClose = (close: () => void, id: string) => {
	const closeCalendar = useCallback(
		(event: MouseEvent | TouchEvent) => {
			const container = document.getElementById(id);

			if (container && !container.contains(event.target as HTMLElement)) {
				close();
			}
		},
		[close, id],
	);

	useEffect(() => {
		if (!window.matchMedia("(pointer: coarse)").matches) {
			document.addEventListener('click', closeCalendar);
		} 
		document.addEventListener('touchstart', closeCalendar);
		return () => {
			if (!window.matchMedia("(pointer: coarse)").matches) {
				document.removeEventListener('click', closeCalendar);
			}
			document.removeEventListener('touchstart', closeCalendar);
		};
	}, [closeCalendar]);
};
